var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7615 21.0073C36.0743 19.153 36.0791 16.9153 35.7743 15.0593C35.0685 10.7636 32.8292 6.97474 29.6403 4.27186C27.3465 2.3261 24.5586 0.944985 21.4931 0.341849C18.0139 -0.341492 14.3999 0.00017841 11.1115 1.36205C8.9524 2.25713 6.97136 3.57569 5.27423 5.27281C1.86876 8.67989 -0.00160305 13.1938 1.03093e-06 18.006C0.00160512 22.6467 1.77252 26.8863 4.6727 30.0816C7.59855 33.3058 11.6745 35.4697 16.243 35.9157C18.4518 36.1274 20.6686 35.9413 22.8149 35.3478C24.103 34.9933 25.3494 34.4944 26.5284 33.8608C26.9599 33.5961 27.4924 33.4919 28.0266 33.6154L35.2771 35.2933L33.4179 28.508C33.2832 28.0139 33.3377 27.4701 33.6136 26.9905C34.6851 25.1346 35.4054 23.1199 35.7615 21.0073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbutton);
export default __webpack_public_path__ + "static/media/chatbutton.2267278ffd168076610a29881206cbcb.svg";
export { ForwardRef as ReactComponent };